import AddRelatedTicket from './AddRelatedTicket';

export default AddRelatedTicket;
